<section class="quotation-type">
    <div class="title">
        <h2>{{ 'buyer.create-quotation.quotation-type.header.title' | translate }}</h2>
        <p>{{ 'buyer.create-quotation.quotation-type.header.subtitle' | translate }}</p>
    </div>

    <div class="content">
        <div class="buttons-section">
            <button customButton styleType="secondary" label="buyer.create-quotation.quotation-type.buttons.pecas" [isLoading]="false" [isDisabled]="isQuotationWithParts" [ngClass]="{ 'not-selected': !isQuotationWithParts }" (click)="toggleChangeQuotationType()"></button>
            <button customButton styleType="secondary" label="buyer.create-quotation.quotation-type.buttons.insumos"  [isLoading]="false" [isDisabled]="!isQuotationWithParts" [ngClass]="{ 'not-selected': isQuotationWithParts }" (click)="toggleChangeQuotationType()"></button>
        </div>

        @if (isQuotationWithParts) {
            <button class="import-file" customButton styleType="secondary" label="buyer.create-quotation.quotation-type.buttons.orcamento" iconName="upload" [outline]="true" [isLoading]="false" (click)="openImportFile()"></button>
        }
    </div>
</section>
